import type { Content, StyleDictionary } from 'pdfmake/interfaces';
import { Services } from '../../../services';
import { MAGIC_SCALING_NUMBER, pdfTheme } from '../pdfTheme';
import type { BaseReportComponent } from './BaseReportComponent';

export interface ImageReference {
	reference: string;
	timeStamp?: Date;
}

export class ImageComponent implements BaseReportComponent {
	constructor(
		private imageReference: ImageReference,
		private availableWidth: number,
		private availableHeight: number = pdfTheme.page.height
	) {}

	exportContent(): Content {
		if (!this.imageReference.timeStamp) {
			return {
				image: this.imageReference.reference,
				fit: [this.availableWidth, this.availableHeight],
			};
		}

		const dateString = Services.DateTime.formatDate(this.imageReference.timeStamp.toISOString());

		const fontSize = (14 * this.availableWidth) / pdfTheme.page.width;

		const rect = {
			type: 'rect' as const,
			x: 0,
			y: 0,
			w: this.availableWidth / 4,
			h: fontSize * 1.5,
			color: pdfTheme.background.default,
			fillOpacity: 0.8,
		};

		return {
			/**
			 *  because we dont know how the image is going to be scaled
			 *  centering is the easiest way to line up the text and its background
			 */
			alignment: 'center' as const,
			unbreakable: true,
			stack: [
				{
					image: this.imageReference.reference,
					fit: [this.availableWidth, this.availableHeight],
					alignment: 'center',
				},
				...(this.imageReference.timeStamp && [
					{
						relativePosition: {
							x: 0,
							y: -fontSize * 1.5,
						},
						canvas: [rect],
					},
					{
						text: dateString,
						style: ['dateText'],
						fontSize,
						relativePosition: {
							x: 0,
							y: -fontSize * MAGIC_SCALING_NUMBER,
						},
					},
				]),
			],
		};
	}

	exportStyles(): StyleDictionary {
		// NOTE: This value will also determine the y position of the table and date text above ^^^

		return {
			dateText: {
				color: pdfTheme.font.color.dark,
			},
		};
	}
}
